<!-- DropdownMenu.vue -->
<template>
    <div class="navbar-item relative group inline px-1" 
         @mouseover="showDropdownImmediately" 
         @mouseleave="hideDropdownAfterDelay">
      <a href="/about" class="navbar-item m-0 p-0">{{title}}</a>
      <span class="dropdown-arrow inline-block ml-2"></span>
      <div class="dropdown absolute left-0 mt-2 w-48 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 m-0 p-0" 
           v-if="showDropdown">
        <div class="py-1 m-0 p-0" role="menu" aria-orientation="vertical" aria-labelledby="options-menu">
          <a v-for="item in items" :key="item.text" :href="item.link" 
             class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 hover:text-gray-900 m-0 p-0" 
             role="menuitem">{{ item.text }}</a>
        </div>
      </div>
    </div>
  </template>
  
  
  <script>
  export default {
    props: ['title', 'link', 'items'],
    data() {
      return {
        showDropdown: false,
      }
    },
    methods: {
      showDropdownImmediately() {
        clearTimeout(this.hideTimeout);
        this.showDropdown = true;
      },
      hideDropdownAfterDelay() {
        this.hideTimeout = setTimeout(() => {
          this.showDropdown = false;
        }, 150); // Adjust delay as needed
      }
  }
  }
  </script>
  <style>
  .dropdown-arrow::after {
    content: '';
    display: inline-block;
    width: 0.5em;
    height: 0.5em;
    border-right: 2px solid currentColor;
    border-bottom: 2px solid currentColor;
    transform: translateY(-2px) rotate(45deg);
  }
  </style>